<template>
  <div>
    <a-card title="生码管理">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 240px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="产品名称, 批号, 备注" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="openFormModal({})">新建批次</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange" :scroll="{ x: 1000 }">
          <div slot="charset" slot-scope="value">
            <a-tag>{{ charsetMap[value] || value }}</a-tag>
          </div>
          <div slot="progress" slot-scope="value, item">
            {{ item.generated_quantity }} / {{ item.quantity }}
          </div>
          <div slot="action" slot-scope="value, item" class="action-cell">
            <a-tooltip title="生码">
              <a-button icon="thunderbolt" size="small" type="primary" @click="openGenerate(item)" />
            </a-tooltip>
            <a-tooltip title="导出溯源码">
              <a-button icon="download" size="small" @click="exportCodes(item)" />
            </a-tooltip>
            <a-tooltip title="下载二维码">
              <a-button icon="qrcode" size="small" @click="downloadQrcodes(item)" />
            </a-tooltip>
            <a-tooltip title="编辑">
              <a-button icon="edit" size="small" @click="openFormModal(item)" />
            </a-tooltip>
            <a-popconfirm title="确定删除吗? 批次下的所有溯源码将一并删除" @confirm="destroy(item.id)">
              <a-tooltip title="删除">
                <a-button type="danger" icon="delete" size="small" />
              </a-tooltip>
            </a-popconfirm>
          </div>
        </a-table>
      </a-row>
    </a-card>

    <form-modal v-model="visible" :form="targetItem" :templates="templates" @create="list" @update="list" />

    <a-modal v-model="generateVisible" title="生码" :confirmLoading="generateLoading" :maskClosable="false"
      @ok="confirmGenerate">
      <div v-if="generateTarget.id">
        <p>产品名称: <b>{{ generateTarget.product_name }}</b></p>
        <p>批号: <b>{{ generateTarget.batch_number }}</b></p>
        <p>剩余可生成: <b>{{ generateTarget.quantity - generateTarget.generated_quantity }}</b> 个</p>
        <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="本次生成数量">
            <a-input-number v-model="generateQuantity" :min="1"
              :max="generateTarget.quantity - generateTarget.generated_quantity" style="width: 100%" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>

    <a-modal v-model="downloadLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px;" />正在打包下载, 请稍候...</div>
    </a-modal>
  </div>
</template>

<script>
  import {
    traceBatchList, traceBatchDestroy, traceBatchGenerate,
    traceBatchExport, traceBatchQrcodes, traceTemplateList,
  } from '@/api/trace'

  function downloadBlob(data, filename) {
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  export default {
    name: 'TraceBatch',
    components: {
      FormModal: () => import('./FormModal.vue'),
    },
    data() {
      return {
        charsetMap: { digit: '纯数字', upper: '大写字母', alnum: '数字+字母' },
        columns: [
          { title: '序号', dataIndex: 'index', customRender: (v, item, index) => index + 1, width: 60 },
          { title: '产品名称', dataIndex: 'product_name', sorter: true },
          { title: '批号', dataIndex: 'batch_number', sorter: true },
          { title: '码前缀', dataIndex: 'prefix' },
          { title: '字符集', dataIndex: 'charset', scopedSlots: { customRender: 'charset' } },
          { title: '字符长度', dataIndex: 'code_length' },
          { title: '已生成/总数', dataIndex: 'progress', scopedSlots: { customRender: 'progress' } },
          { title: '关联产品', dataIndex: 'goods_name' },
          { title: '模板', dataIndex: 'template_name' },
          { title: '创建时间', dataIndex: 'create_time' },
          { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 180, fixed: 'right', align: 'center' },
        ],
        searchForm: { search: '', page: 1, page_size: 16 },
        pagination: { current: 1, total: 0, pageSize: 16 },
        loading: false,
        items: [],
        templates: [],

        visible: false,
        targetItem: {},

        generateVisible: false,
        generateLoading: false,
        generateTarget: {},
        generateQuantity: 1,

        downloadLoading: false,
      };
    },
    methods: {
      initialize() {
        this.list();
        this.loadTemplates();
      },
      list() {
        this.loading = true;
        traceBatchList(this.searchForm).then(data => {
          this.pagination.total = data.count;
          this.items = data.results;
        }).finally(() => {
          this.loading = false;
        });
      },
      loadTemplates() {
        traceTemplateList({ page_size: 999 }).then(data => {
          this.templates = data.results;
        });
      },
      search() {
        this.searchForm.page = 1;
        this.pagination.current = 1;
        this.list();
      },
      openFormModal(item) {
        this.targetItem = { ...item };
        this.visible = true;
      },
      destroy(id) {
        traceBatchDestroy({ id }).then(() => {
          this.$message.success('删除成功');
          this.list();
        });
      },
      openGenerate(item) {
        this.generateTarget = { ...item };
        this.generateQuantity = item.quantity - item.generated_quantity;
        this.generateVisible = true;
      },
      confirmGenerate() {
        this.generateLoading = true;
        traceBatchGenerate(this.generateTarget.id, { quantity: this.generateQuantity })
          .then(data => {
            this.$message.success(`本次生成 ${data.generated} 个, 累计 ${data.total} 个`);
            this.generateVisible = false;
            this.list();
          })
          .finally(() => {
            this.generateLoading = false;
          });
      },
      exportCodes(item) {
        traceBatchExport(item.id).then(resp => {
          downloadBlob(resp.data, `${item.batch_number}_溯源码.xlsx`);
        }).catch(() => {
          this.$message.error('导出失败');
        });
      },
      downloadQrcodes(item) {
        this.downloadLoading = true;
        traceBatchQrcodes(item.id).then(resp => {
          downloadBlob(resp.data, `${item.batch_number}_二维码.zip`);
        }).catch(() => {
          this.$message.error('下载失败, 请确认该批次已生码');
        }).finally(() => {
          this.downloadLoading = false;
        });
      },
      tableChange(pagination, filters, sorter) {
        this.searchForm.page = pagination.current;
        this.pagination.current = pagination.current;
        this.searchForm.ordering = sorter.field ? `${sorter.order == 'descend' ? '-' : ''}${sorter.field}` : undefined;
        this.list();
      },
    },
    mounted() {
      this.initialize();
    },
  }
</script>

<style scoped>
  .action-cell {
    display: flex;
    justify-content: center;
    gap: 4px;
  }
  .action-cell >>> .ant-btn {
    padding: 0 7px;
  }
</style>
